import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import { reduxKey } from './constants';
import get from 'lodash/get';
export function getWatchState(state, username) {
    return username ? state[reduxKey][username.toLowerCase()] : {};
}
export function getIsInitialized(state, username) {
    return Boolean(username) && state[reduxKey] !== undefined && state[reduxKey][username.toLowerCase()] !== undefined;
}
export function getUserWatchState(state, user, initialState) {
    const username = get(user, 'username');
    var _initialState_isWatching, _ref;
    const initialIsWatching = (_ref = (_initialState_isWatching = initialState === null || initialState === void 0 ? void 0 : initialState.isWatching) !== null && _initialState_isWatching !== void 0 ? _initialState_isWatching : get(user, 'isWatching')) !== null && _ref !== void 0 ? _ref : false;
    if (!username) {
        return {
            isWatching: initialIsWatching,
            isLoading: false
        };
    }
    const userState = getWatchState(state, username);
    return _object_spread({
        isWatching: initialIsWatching,
        isLoading: false
    }, userState);
}
export function getIsWatching(state, username) {
    return get(getWatchState(state, username), 'isWatching');
}
export function getIsLoading(state, username) {
    return get(getWatchState(state, username), 'isLoading');
}
